import { LoadableLazy } from '@confluence/loadable';

export const EditorControlsTour = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditorControlsTour" */ '../src/EditorControlsTour'
			)
		).EditorControlsTour,
});
